var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSweepstakes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69385 9.49377H5.81885V11.025H6.69385V9.49377Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69385 12.1188H5.81885V13.65H6.69385V12.1188Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69385 14.7875H5.81885V16.3188H6.69385V14.7875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69385 17.4125H5.81885V18.9438H6.69385V17.4125Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95625 0.262512L4.725 3.80626L5.03125 4.06876C5.90625 4.72501 6.125 5.95001 5.5125 6.86876C4.94375 7.78751 3.7625 8.13751 2.8 7.61251L2.45 7.43751L2.1875 7.87501H0.4375V12.075L0.83125 12.1188C1.925 12.2063 2.75625 13.125 2.75625 14.2188C2.75625 15.3125 1.925 16.2313 0.83125 16.3188L0.4375 16.3625V20.5625H20.5625V16.3625L20.1687 16.3188C19.4688 16.2313 18.8125 15.7938 18.5063 15.1375C18.375 14.8313 18.2875 14.525 18.2875 14.2188C18.2875 13.125 19.1187 12.2063 20.1687 12.1188L20.5625 12.075V7.87501H19.075L6.95625 0.262512ZM6.3 7.35001C7.04375 6.16876 6.86875 4.63751 5.90625 3.67501L7.2625 1.48751L17.4125 7.87501H9.58125L9.975 7.21876L9.23125 6.73751L8.575 7.87501H5.8625C5.99375 7.70001 6.16875 7.52501 6.3 7.35001ZM19.6875 11.3313C18.375 11.6375 17.3687 12.8188 17.3687 14.2188C17.3687 14.6563 17.4563 15.1375 17.675 15.5313C18.0688 16.3188 18.8125 16.9313 19.6438 17.1063V19.6875H1.3125V17.1063C2.66875 16.8 3.63125 15.6188 3.63125 14.2188C3.63125 12.8188 2.66875 11.6375 1.3125 11.3313V8.75001H1.61875H19.6875V11.3313Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6846 4.49454L9.87061 5.7915L10.6117 6.25665L11.4257 4.95969L10.6846 4.49454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweepstakes);
export default __webpack_public_path__ + "static/media/sweepstakes.2393bb1386fbbce9f6d95722773f4677.svg";
export { ForwardRef as ReactComponent };